import { render, staticRenderFns } from "./CustomerSnRuleDetailsEdit.vue?vue&type=template&id=23120be4&"
import script from "./CustomerSnRuleDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerSnRuleDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports